<template>
    <div v-if="loading" class="loading-bar">
        <atom-spinner
            :animation-duration="1000"
            :size="60"
            color="#ff1d5e"
            class="mx-auto"
        />
    </div>
    <div v-else>
        <b-row>
            <b-col cols="12" md="12">
                <component-header
                    title="Edit Return & Cancellation Policy"
                    :hasSearch="false"
                    :hasCreate="false"
                    :hasClear="false"
                    :hasReload="false"
                    :hasback="true"
                    @back-press="$router.push({ path: '/setup/policy' })"
                />
            </b-col>
            <b-col cols="12" md="12">
                <b-card class="custome-card">
                    <form>
                        <b-row>
                            <b-col cols="12" sm="12" md="6" class="mt-2">
                                <label for="productType">Product Type </label>
                                <multiselect
                                    v-model="returnPolicy.productType"
                                    tag-placeholder="Add this as new product type"
                                    placeholder="Select Product Type"
                                    label="name"
                                    track-by="_id"
                                    :options="productTypeList"
                                    :multiple="true"
                                    :taggable="false"
                                    :open-direction="'bottom'"
                                ></multiselect>
                            </b-col>
                            <b-col cols="12" sm="12" md="6" class="mt-2">
                                <label for="planName"
                                    >Return & Replacement Window Days</label
                                >
                                <b-form-input
                                    id="planName"
                                    inputType="text"
                                    placeholder="Enter Return Window(in days)"
                                    v-model="returnPolicy.returnWindow"
                                />
                            </b-col>
                            <b-col cols="12" sm="6" md="4" class="mt-4">
                                <v-switch
                                    class="pt-1 float-left switch-adjustment-class"
                                    color="indigo"
                                    label="Allow Return"
                                    v-model="returnPolicy.allowReturn"
                                >
                                </v-switch>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" class="mt-4">
                                <v-switch
                                    class="pt-1 float-left switch-adjustment-class"
                                    color="indigo"
                                    label="Allow Replacement"
                                    v-model="returnPolicy.allowReplacement"
                                >
                                </v-switch>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" class="mt-4">
                                <v-switch
                                    class="pt-1 float-left switch-adjustment-class"
                                    color="indigo"
                                    label="Return Approval Require"
                                    v-model="returnPolicy.returnApproval"
                                >
                                </v-switch>
                            </b-col>
                            <b-col cols="12" sm="12" md="6">
                                <b-form-group class="mt-2 ml-3">
                                    <label>Refund Mode</label>
                                    <b-form-checkbox-group
                                        id="refund-mode-group"
                                        v-model="returnPolicy.selectedRefundMode"
                                        :options="refundModeOptions"
                                        name="refund-modes"
                                    ></b-form-checkbox-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="12" md="6">
                                <b-form-group class="mt-2 ml-3">
                                    <label>Allow Cancellation</label>
                                    <b-form-radio-group
                                        id="cancellation-group"
                                        v-model="returnPolicy.selectedCancellation"
                                    >
                                        <b-form-radio value="BEFORE_APPROVAL"
                                            >Before Approval</b-form-radio
                                        >
                                        <b-form-radio value="BEFORE_DELIVERY"
                                            >Before Delivery</b-form-radio
                                        >
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12">
                                <label>Note</label>
                                <textarea
                                    rows="4"
                                    cols="30"
                                    id="title"
                                    class="form-control custom-transform-class"
                                    inputType="text"
                                    maxlength="300"
                                    v-model="returnPolicy.note"
                                ></textarea>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <div class="text-center mb-0 p-4">
                                    <button
                                        type="button"
                                        class="text-uppercase btn btn-sm btn-danger mr-2 action-btn"
                                        @click="
                                            $router.push({
                                                name: 'Return & Cancellation Policy',
                                            })
                                        "
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        class="text-uppercase btn btn-sm btn-primary action-btn"
                                        classic="mr-1 btn-primary"
                                        text="Update"
                                        @click="handleSubmit"
                                    >
                                        Update
                                    </button>
                                </div>
                            </b-col>
                        </b-row>
                    </form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader/index.vue";
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import returnPolicyCatalogMixin from "@/views/setup/return-policy/returnPolicyCatalogMixin";
import { REFUND_MODE_OPTIONS } from "@/views/setup/return-policy/constants";

export default {
    name: "Edit Return Policy",
    components: {
        ComponentHeader,
        AtomSpinner,
    },
    mixins: [returnPolicyCatalogMixin],
    data() {
        return {
            returnPolicy: {
                productType: [],
                allowReturn: false,
                allowReplacement: false,
                returnWindow: "",
                replacementWindow: "",
                returnApproval: false,
                note: "",
                selectedRefundMode: [],
                selectedCancellation: null,
            },
            productTypeList: [],
            loading: false,
            refundModeOptions: REFUND_MODE_OPTIONS,
        };
    },
    computed: {
        ...mapState({
            getPolicyById: (state) => state.returnPolicy.returnPolicyDetails,
        }),
    },
    methods: {
        async fetchPolicyDetails() {
            try {
                await this.$store.dispatch(
                    "returnPolicy/viewReturnPolicy",
                    this.$route.params.id,
                );
                const policy = this.getPolicyById?.[0];
                if (policy) {
                    this.assignPolicyValues(policy);
                }
            } catch (error) {
                this.$toasted.error("Unable to fetch data");
            }
        },
        assignPolicyValues(policy) {
            this.returnPolicy.productType = this.productTypeList.filter(
                (item) => policy.catalogId && policy.catalogId.includes(item._id),
            );
            this.returnPolicy.allowReturn = policy.allowReturn;
            this.returnPolicy.allowReplacement = policy.allowReplacement;
            this.returnPolicy.returnWindow = policy.returnWindowDays;
            this.returnPolicy.replacementWindow = policy.replacementWindowDays;
            this.returnPolicy.returnApproval = policy.approvalRequired;
            this.returnPolicy.selectedRefundMode = policy.refundMode || [];
            this.returnPolicy.selectedCancellation =
                policy.allowCancellation || null;
            this.returnPolicy.note = policy.notes || "";
        },
        async handleSubmit() {
            const payload = {
                id: this.$route.params.id,
                data: {
                    catalogId: this.returnPolicy.productType.map((p) => p._id),
                    provider: this.$currentUserData?.catalogInfo?.[0]?._id,
                    allowReturn: this.returnPolicy.allowReturn,
                    allowReplacement: this.returnPolicy.allowReplacement,
                    returnWindowDays: this.returnPolicy.returnWindow,
                    replacementWindowDays: this.returnPolicy.returnWindow,
                    approvalRequired: this.returnPolicy.returnApproval,
                    refundMode: this.returnPolicy.selectedRefundMode,
                    allowCancellation: this.returnPolicy.selectedCancellation,
                    notes: this.returnPolicy.note,
                },
            };
            try {
                await this.$store.dispatch(
                    "returnPolicy/updateReturnPolicy",
                    payload,
                );
                this.$toasted.success("Policy updated successfully");
                this.$router.push({ name: "Return & Cancellation Policy" });
            } catch (error) {
                console.error("Error updating policy:", error);
                this.$toasted.error("Failed to update policy");
            }
        },
    },
    async mounted() {
        this.loading = true;
        try {
            this.productTypeList = await this.fetchProductTypeList();
            await this.fetchPolicyDetails();
        } finally {
            this.loading = false;
        }
    },
};
</script>

<style scoped>
.action-btn {
    width: 100px;
    height: 35px;
}
@media (max-width: 576px) {
    .action-btn {
        margin-top: 5px;
        margin-right: 8px;
    }
}
</style>
